interface LogoProps {
  className?: string;
  size?: "sm" | "md" | "lg";
  showSubtitle?: boolean;
}

export function Logo({ className = "", size = "md", showSubtitle = false }: LogoProps) {
  const sizeMap = {
    sm: {
      wrapper: "gap-0",
      aura: "text-[20px] tracking-[0.3em]",
      digital: "text-[7px] tracking-[0.35em]",
    },
    md: {
      wrapper: "gap-0.5",
      aura: "text-[26px] tracking-[0.3em]",
      digital: "text-[8.5px] tracking-[0.4em]",
    },
    lg: {
      wrapper: "gap-1",
      aura: "text-[32px] sm:text-[40px] tracking-[0.3em]",
      digital: "text-[9px] sm:text-[11px] tracking-[0.45em]",
    },
  };

  const s = sizeMap[size];

  return (
    <div className={`inline-flex flex-col items-center ${s.wrapper} ${className}`}>
      <span
        className={`font-heading ${s.aura} font-light leading-none bg-gradient-to-r from-[#D4A574] via-[#E8C9A0] to-[#C9956B] bg-clip-text text-transparent select-none`}
      >
        AURA
      </span>
      {showSubtitle && (
        <span
          className={`font-sans ${s.digital} font-medium uppercase leading-none text-[#9e8b7a]`}
        >
          Digital
        </span>
      )}
    </div>
  );
}
